import styled from 'styled-components';

export const Title = styled.div`
    font-size: 16px;
    font-weight: 300;
    line-height: 1.38;
    color: #000000;
    margin-bottom: 10px;
`;

export const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            margin: 0 !important;
            ${props => (props.isAddressSubmitting ? `text-indent: -99999px;` : '')};
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            top: 7px;
            right: ${props =>
                props.rightPosition ? props => props.rightPosition : '25'}%;
            margin-right: -16px;
            width: 32px !important;
            height: 32px !important;
            ${props => (props.isAddressSubmitting ? `display: block` : 'display: none')};
        }
    }
`;

export const AddressPopupContainer = styled.form`
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const FormGroup = styled.div`
    margin-bottom: 0.75em;
`;

export const MultipleGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin-bottom: 0.75em;

    @media (max-width: 22em) {
        display: inline-block;

        > div {
            margin: 0 0 0.75em 0 !important;
        }
    }

    > div {
        position: relative;
    }

    button:first-child,
    div:first-child,
    .middleButton {
        margin-right: 0.5em;
    }

    button:last-child,
    div:last-child {
        margin-left: 0.5em;
    }
`;

export const Container = styled.form`
    position: relative;
    height: 100%;
`;

export const ButtonGroupWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    @media (max-width: 30em) {
        bottom: -66px;
    }

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            margin-left: 0.5em;
            ${props => (props.isFormSubmitting ? `text-indent: -99999px;` : '')};
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            top: 7px;
            right: ${props =>
                props.rightPosition ? props => props.rightPosition : '25'}%;
            margin-right: -16px;
            width: 32px !important;
            height: 32px !important;
            ${props => (props.isFormSubmitting ? `display: block` : 'display: none')};
        }
    }
`;

export const MultipleGroupWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin: 0 -0.5em 0.75em -0.5em;

    > div {
        position: relative;
        margin: 0 0.5em;
    }

    > div:first-child {
        margin-right: 0.5em;
        flex: 0.65;
    }

    > div:last-child {
        margin-left: 0.5em;
    }
`;

export const MultipleGroupLast = MultipleGroupWrapper.extend`
    > div:first-child {
        flex: 1.5;
    }
`;

export const MultipleGroupHalf = MultipleGroupWrapper.extend`
    > div:first-child {
        flex: 1;
    }
`;
export const MultipleGroupFirstMed = MultipleGroupWrapper.extend`
    > div:first-child {
        flex: 1.15;
    }
`;

export const MultipleGroupFull = MultipleGroupWrapper.extend`
    > div:first-child {
        flex: 1;
    }
`;

export const MultipleGroupLastLarge = MultipleGroupWrapper.extend`
    > div:first-child {
        flex: 3;
    }
`;
export const MultipleGroupVolunteerWithCountry = MultipleGroupWrapper.extend`
    > div:first-child {
        flex: 2;
    }
    > div {
        flex: 1;
    }
    > div:last-child {
        flex: 3;
    }
`;

export const Label = styled.label`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 0.5em;
`;

export const MultiChoiceGroup = styled.div`
    flex: 1;
    justify-content: flex-start;
    display: flex;
    flex-direction: column;

    div {
        margin: 2px 0;
    }
`;



// WEBPACK FOOTER //
// ./src/containers/DefaultStyles/FormDetails.jsx